import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

import TranslationModel from '@/views/Language/models/translation'
import StringModel from '@/views/Language/models/string'

@Component({
    name: 'unsaved-translation-dialog',
    components: { DialogTemplate },
})
export default class UnsavedTranslationDialog extends Mixins<MixinInterface>() {
    bottomSheet = true
    @Prop({ required: true }) props!: any

    get token() {
        return this.$route.params.token
    }

    get string(): StringModel | null {
        return this.props.string
    }

    get translation(): TranslationModel | null {
        return this.props.translation
    }

    get text(): string | null {
        return this.props.text
    }

    loading = false

    async submit() {
        if (this.translation) {
            this.loading = true
            await this.translation.patchText(this.text, this.token)
            this.loading = false
            this.$emit('close', true)
        }
    }
}
